export default __webpack_public_path__ + "static/media/RB_Matrix.21177511.jpg";